export const UiConfig = {
  tooltip: {
    showDelay: 1000, // ms
  },
} as const;
